module.exports = __webpack_public_path__ + "static/canzhengyizheng.109f41bb.jpg";